import { FieldMarshaller } from "@cervval.js/common-sql-core";
import { anyObject } from "@cervval.js/common/src/tools/any.tools";
import { NUMBER } from "./property.types";

export const jsonDataFieldMarshaller: FieldMarshaller<anyObject, string> = {
    marshal: (b: anyObject) => { return b ? JSON.stringify(b) : undefined; },
    unmarshal: (n: string) => { return n == null ? undefined : n.length ? JSON.parse(n) : {}; }
};

export const BooleanFieldMarshaller: FieldMarshaller<boolean, number> = {
    marshal: (b: boolean) => { return b ? 1 : 0; },
    unmarshal: (n: number) => { return n === 1 ? true : false; }
};

/** marshaller to convert bigint to number. It is required due to a postgres connector's "bug", (written in vanilla JS), in which big int is interpreted as a string */
export const BigIntFieldMarshaller: FieldMarshaller<number, number> = {
    marshal: (i: number) => i,
    unmarshal: (i: number) => {
        if (i == null) {
            return undefined;
        }
        return Number(i);
    }
};

/** Each enum value must be shifted by 1 bit (enum value = 1 << 0, 1, 2, 3...) */
export const EnumArrayMarshaller: FieldMarshaller<NUMBER[], NUMBER> = {
    marshal: (array: NUMBER[]) => {
        const binarySum = array.reduce((a, b) => a | b, 0);
        return binarySum;
    },
    unmarshal: (binary: NUMBER) => {
        const array: NUMBER[] = [];
        let position = 0;

        while (binary > 0) {
            if (binary & 1) {
                array.push(1 << position);
            }
            binary >>= 1; // Shift 
            position++;
        }
        return array;
    }
};